import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

const up = (el: HTMLElement) => {
    const delay = el.dataset.delay ? parseInt(el.dataset.delay) : .2;
    gsap.fromTo(el, {
        opacity: 0,
        yPercent: 25,
    }, {
        opacity: 1,
        yPercent: 0,
        duration: 1,
        delay: delay,
        ease: 'power4.out',
    });
}
const left = (el: HTMLElement) => {
    const delay = el.dataset.delay ? parseInt(el.dataset.delay) : .2;
    gsap.fromTo(el, {
        opacity: 0,
        xPercent: 25,
    }, {
        opacity: 1,
        xPercent: 0,
        duration: 1,
        delay: delay,
        ease: 'power4.out',
    });
}

const scaleDown = (el: HTMLElement) => {
    const delay = el.dataset.delay ? parseInt(el.dataset.delay) : .2;
    gsap.fromTo(el, {
        scale: 1.1,
        opacity: 0,
    }, {
        scale: 1,
        opacity: 1,
        duration: 1,
        delay: delay,
        ease: 'power4.out',
    });
}

const scaleUp = (el: HTMLElement) => {
    const delay = el.dataset.delay ? parseInt(el.dataset.delay) : .2;
    gsap.fromTo(el, {
        scale: 0.,
        opacity: 0,
    }, {
        scale: 1,
        opacity: 1,
        duration: 1,
        delay: delay,
        ease: 'power4.out',
    });
}

const initInview = () => {
    const $upEls = gsap.utils.toArray<HTMLElement>('[data-inview="up"]');
    const $leftEls = gsap.utils.toArray<HTMLElement>('[data-inview="left"]');
    const $textEls = gsap.utils.toArray<HTMLElement>('[data-inview="text"]');
    const $scaleDownEls = gsap.utils.toArray<HTMLElement>('[data-inview="scale-down"]');
    const $scaleUpEls = gsap.utils.toArray<HTMLElement>('[data-inview="scale-up"]');

    if($upEls.length > 0){
        $upEls.forEach((el) => {
            const playForce = el.dataset.playForce === 'true';
            if(playForce){
                up(el);
            }
            else {
                ScrollTrigger.create({
                    trigger: el,
                    start: 'top 85%',
                    once: true,            
                    onEnter: () => {
                        up(el);
                    },
                });
            }
        });
    }

    if($leftEls.length > 0){
        $leftEls.forEach((el) => {
            const playForce = el.dataset.playForce === 'true';
            if(playForce){
                left(el);
            }
            else {                
                ScrollTrigger.create({
                    trigger: el,
                    start: 'top 85%',
                    once: true,
                    onEnter: () => {
                        left(el);
                    },
                });
            }
        });
    }

    if($scaleDownEls.length > 0){
        $scaleDownEls.forEach((el) => {
            const playForce = el.dataset.playForce === 'true';
            if(playForce){
                scaleDown(el);
            }
            else {
                ScrollTrigger.create({
                    trigger: el,
                    start: 'top 85%',
                    once: true,
                    onEnter: () => {
                        scaleDown(el);
                    },
                });
            }
        });
    }

    if($scaleUpEls.length > 0){
        $scaleUpEls.forEach((el) => {
            const playForce = el.dataset.playForce === 'true';
            if(playForce){
                scaleUp(el);
            }
            else {
                ScrollTrigger.create({
                    trigger: el,
                    start: 'top 85%',
                    once: true,
                    onEnter: () => {
                        scaleUp(el);
                    },
                });
            }
        });
    }

    if($textEls.length > 0){
        $textEls.forEach((el) => {
            const splitText = new SplitText(el, {
                type: 'chars',
            });
            gsap.set(el, {
                overflow: 'clip',
            })            
            gsap.set(splitText.chars, {
                opacity: 0,
                yPercent: 100,
                duration: 1,
                ease: 'power4.out',
            });
            ScrollTrigger.create({
                trigger: el,
                start: 'top 90%',
                once: true,
                onEnter: () => {
                    gsap.to(splitText.chars, {
                        opacity: 1,
                        yPercent: 0,
                        duration: 1.2,
                        stagger: 0.03,
                        ease: 'power4.out',
                    });
                },
            });
        });
    }
}

export default initInview;